import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtilsService } from './http-utils.service';
import { environment } from 'src/environments/environment';
import { Observable, catchError, map, mergeMap, of } from 'rxjs';
import { JsonConvert } from 'json2typescript';
import { Counters, CountersData } from '../../models/counters';
import { Paging } from '../../models/paging';
import { Device, DeviceListData } from '../../models/device';
import { DeviceLogData, DeviceTimeline, DeviceTimelineData } from '../../models/monitoring';
import { EventStatusConverter } from '../../models/event-status';
import { MonitoringDeviceData, MonitoringDeviceList, MonitoringDeviceListData } from '../../models/monitoring-device';
import { BooleanResp } from '../../models/boolean-resp';
import { MonitoringFirewallList } from '../../models/monitoring-firewall';
import { MonitoringDetailedLog, MonitoringDetailedLogList, MonitoringDetailedLogListData } from '../../models/monitoring-detailed';

@Injectable({
    providedIn: 'root'
})
export class MonitoringService {
    private _url: string = `${environment.baseAPI}/monitoring`;

    constructor(private _http: HttpClient, private _httpUtils: HttpUtilsService) { }


    // DA RIMUOVERE
    // GETMonitoringCounters():Observable<Counters>{
    // 	const mockData = {
    //         data:{
    //             count: 36,
    //         	online: 23,
    //             offline: 13,
    //         }
    //     }
    //     const jsonConvert: JsonConvert = new JsonConvert();
    //     const response:CountersData  = jsonConvert.deserializeObject(mockData, CountersData);
    //     return of(response.data);
    // }

    // DA RIMUOVERE
    // GETMonitoringDevices(paging:Paging):Observable<MonitoringDeviceList>{
    //     const mockData = {
    //         success: true,
    //         errorCode:0,
    //         errorMessage:"",
    //         elapsed:0,
    //         data:{
    //             count:10,
    //             data:Array.from({length:10}, (_, index) => ({
    //                 uuid: `${index + 1}`,
    //                 mac: '11:11:11:11:11:11',
    //                 name: `name_${index + 1}`,
    //                 ip: `192.168.1.${index}`,
    //                 last_seen: 1701333433,
    //                 last_seen_nasid: `nasid_${index + 1}`,
    //                 monitoring: true,
    //                 status: true,
    //             })),
    //         }
    //     };
    //     const jsonConvert: JsonConvert = new JsonConvert();
    //     const response: MonitoringDeviceListData = jsonConvert.deserializeObject(mockData, MonitoringDeviceListData);
    //     return of(response.data);
    // }

    // DA ABILITARE
    GETMonitoringCounters(): Observable<Counters> {
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}/counters`, { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: CountersData = jsonConvert.deserializeObject(res, CountersData);
                            if (response.success) {
                                return response.data;
                            } else {
                                this._httpUtils.handleError(response);
                                return new Counters();
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }



    // DA ABILITARE
    GETMonitoringDevices(paging: Paging): Observable<any> {
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}/devices${paging.getQs()}`, { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: MonitoringDeviceListData = jsonConvert.deserializeObject(res, MonitoringDeviceListData);
                            if (response.success) {
                                return response.data;
                            } else {
                                this._httpUtils.handleError(response);
                                return;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    GETMonitoringDevicesTimeline(from: string, to: string, mac: string) {
    	try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}/devices/${mac}/timeline?from=${from}&to=${to}`, { headers: httpHeaders }).pipe(
                        map((res:any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: DeviceTimelineData = jsonConvert.deserializeObject(res, DeviceTimelineData);
                            if (response.success) {
                            	return response;
                            } else {
                            	this._httpUtils.handleError(response);
                                return new DeviceTimelineData();
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    // DA ELIMINARE
    GETMonitoringDevicesLogs(from: string, to: string, mac: string, status: string) {
        const mockData =
            [
                {
                    "timestamp": 1638368421,
                    "status": "LOGIN",
                    "log_message": "User logged in"
                },
                {
                    "timestamp": 1638368432,
                    "status": "LOGOUT",
                    "log_message": "User logged out"
                },
                {
                    "timestamp": 1638368443,
                    "status": "INARPTABLE",
                    "log_message": "Device in ARP table"
                },
                {
                    "timestamp": 1638368454,
                    "status": "NOTINARPTABLE",
                    "log_message": "Device not in ARP table"
                },
                {
                    "timestamp": 1638368465,
                    "status": "INDHCP",
                    "log_message": "Device in DHCP table"
                },
                {
                    "timestamp": 1638368476,
                    "status": "NOTINDHCP",
                    "log_message": "Device not in DHCP table"
                },
                {
                    "timestamp": 1638368487,
                    "status": "TRAFFIC",
                    "log_message": "High traffic detected"
                },
                {
                    "timestamp": 1638368498,
                    "status": "NOTTRAFFIC",
                    "log_message": "Normal traffic"
                },
                {
                    "timestamp": 1638368509,
                    "status": "LOGIN",
                    "log_message": "User logged in"
                },
                {
                    "timestamp": 1638368520,
                    "status": "LOGOUT",
                    "log_message": "User logged out"
                }
            ]
        return of(mockData);

    }


    // DA ABILITARE
    // GETMonitoringDevicesLogs(from: number, to: number, device_uuid:string, status:string){
    // 	try {
    //         return this._httpUtils.getHTTPHeadersAsync().pipe(
    //             mergeMap(httpHeaders => {
    //                 return this._http.get(`${this._url}/devices/${device_uuid}/logs?from=${from}&to=${to}&status=${status}`, { headers: httpHeaders }).pipe(
    //                     map((res:any) => {
    //                         const jsonConvert: JsonConvert = new JsonConvert();
    //                         const response: DeviceLogData = jsonConvert.deserializeObject(res, DeviceLogData);
    //                         if (response.success) {
    //                         	return response;
    //                         } else {
    //                         	this._httpUtils.handleError(response);
    //                             return;
    //                         }
    //                     }, catchError(err => {
    //                         if (err.status === 401) { // Unauthorized
    //                             this._httpUtils.logout();
    //                         }
    //                         throw err;
    //                     })));
    //             }), catchError(err => {
    //                 throw err;
    //             })
    //         );
    //     } catch (error) {
    //         throw error;
    //     }
    // }

    PUTMonitoringDevice(body: any, device_uuid: string): Observable<boolean> {
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.put(`${this._url}/devices/${device_uuid}/enable`, body, { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: BooleanResp = jsonConvert.deserializeObject(res, BooleanResp);
                            if (response.success) {
                                return response.data;
                            } else {
                                this._httpUtils.handleError(response);
                                return false;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }


    // DA RIMUOVERE
    /* GETDetailedLog(paging: Paging): Observable<MonitoringDetailedLogListData> {
        const mockData = {
            success: false,
            errorCode: 0,
            errorMessage: "",
            elapsed: 0,
            data: {
                count: 10,
                data: [
                    {
                        hostname: "host_1",
                        ip: "192.168.1.27",
                        mac: `00:11:22:33:44:55`,
                        login: 1,
                        dhcp_lease: 1,
                        arp_table: 1,
                        nasid: "nasid_1",
                        firewall: [
                            {
                                ttl: 1232,
                                status: 1,
                                protocol: "protocol_1",
                                dest_address: 'dest_address_1',
                                dest_port: 'dest_port_1'
                            },
                            {
                                ttl: 5435,
                                status: 0,
                                protocol: "protocol_2",
                                dest_address: 'dest_address_2',
                                dest_port: 'dest_port_2'
                            }
                        ]
                    },
                    {
                        hostname: "host_2",
                        ip: "192.168.1.27",
                        mac: `00:11:22:33:44:55`,
                        login: 2,
                        dhcp_lease: 2,
                        arp_table: 2,
                        nasid: "nasid_2",
                        firewall: [
                            {
                                ttl: 1232,
                                status: 1,
                                protocol: "protocol_3",
                                dest_address: 'dest_address_3',
                                dest_port: 'dest_port_3'
                            },
                            {
                                ttl: 5435,
                                status: 0,
                                protocol: "protocol_4",
                                dest_address: 'dest_address_4',
                                dest_port: 'dest_port_4'
                            }
                        ]
                    }
                ],
            },
        };
        const jsonConvert: JsonConvert = new JsonConvert();
        const response: MonitoringDetailedLogListData = jsonConvert.deserializeObject(mockData, MonitoringDetailedLogListData);
        return of(response);
    } */


    GETDetailedLog(paging:Paging, mac: string, from: string, to: string){
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}/devices/${mac}/detailed-logs${paging.getQs()}&from=${from}&to=${to}`, { headers: httpHeaders }).pipe(
                        map((res:any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: MonitoringDetailedLogListData = jsonConvert.deserializeObject(res, MonitoringDetailedLogListData);
                            if (response.success) {
                            	return response;
                            } else {
                            	this._httpUtils.handleError(response);
                                return new MonitoringDetailedLogListData();
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }
}
